import {
    Component,
    Inject,
    Optional,
    OnInit,
    Input,
    SimpleChanges,
    OnChanges,
    Output,
    EventEmitter
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { OrigenDeFondos } from 'app/main/models/origen-de-fondos.model';
import {PaisService} from '../../../../services/pais.service';
import {Cliente} from '../../../../models/cliente.model';
import {SujetoObligado} from '../../../../models/sujeto-obligado.model';
import {DebidaDiligencia} from '../../../../models/debida-diligencia.model';
import {PonderacionDeRiesgos} from '../../../../models/ponderacion-de-riesgos.model';
import {Direccion} from '../../../../models/direccion.model';


@Component({
  selector: 'ponderacion-de-riesgos-results-table',
  templateUrl: './results-table.component.html',
  styleUrls: ['./results-table.component.scss']
})
export class PonderacionDeRiesgosResultsTableComponent implements OnChanges {

    @Input() debidaDiligencia: DebidaDiligencia;
    @Input() ponderacionDeRiesgos: PonderacionDeRiesgos;
    @Output() totalCalculoChange = new EventEmitter<number>();


    camposCalculo: string[] = ['moneda', 'origenDeFondos', 'sectorDeActividad', 'paisDeOperacion', 'paisDeResidenciaDelCliente',
        'paisDeResidenciaDelBeneficiario', 'paisDeResidenciaDelRelacionado', 'pep', 'toleranciaAlRiesgo'];
    action: string;
    LOCAL_DATA: any;
    totalCalculo: number = 0;

    dataSource = [];
    displayedColumns: string[] = ['factor', 'porcentajeDeIncidencia', 'valor'];

    constructor(
    public dialogRef: MatDialogRef<PonderacionDeRiesgosResultsTableComponent>,
    public translate: TranslateService,
    private servicePais: PaisService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: OrigenDeFondos) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;

    this.recalculate();

  }

    ngOnChanges(changes: SimpleChanges) {
        this.recalculate();
    }

  recalculate(): void{
      this.ponderacionDeRiesgos = this.ponderacionDeRiesgos || new PonderacionDeRiesgos({});

      var poneracionpaisResidenciaCliente = 0;
      const direccionFisicaCliente = (this.debidaDiligencia?.cliente) ? this.getDireccionByType('FISICA', this.debidaDiligencia?.cliente?.personaFisica?.contacto?.direcciones) :
          this.getDireccionByType('FISICA',this.debidaDiligencia?.cliente?.personaJuridica?.contacto?.direcciones);
      poneracionpaisResidenciaCliente = (direccionFisicaCliente!=null && direccionFisicaCliente.pais!=null) ? direccionFisicaCliente.pais.factorDeRiesgo : 0;

      var poneracionpaisResidenciaBeneficiario = 0;

      var direccionFisicaBeneficiario = null;
      if( this.debidaDiligencia?.beneficiarioPersonaFisica || this.debidaDiligencia?.beneficiarioPersonaJuridica){

          direccionFisicaBeneficiario = (this.debidaDiligencia?.beneficiario.tipo == "PERSONA_FISICA") ? this.getDireccionByType('FISICA', this.debidaDiligencia?.beneficiarioPersonaFisica?.contacto?.direcciones) :
              this.getDireccionByType('FISICA', this.debidaDiligencia?.beneficiarioPersonaJuridica?.contacto?.direcciones);

          if(direccionFisicaBeneficiario==null || direccionFisicaBeneficiario.pais==null){
              direccionFisicaBeneficiario = (this.debidaDiligencia?.beneficiario.tipo == "PERSONA_FISICA") ? this.debidaDiligencia?.beneficiarioPersonaFisica?.direccionFisica :
                  this.debidaDiligencia?.beneficiarioPersonaJuridica?.direccionFisica;
          }
          poneracionpaisResidenciaBeneficiario = (direccionFisicaBeneficiario!=null && direccionFisicaBeneficiario.pais!=null) ? direccionFisicaBeneficiario.pais.factorDeRiesgo : 0;

          }

      this.dataSource = [
          {factor: 'Moneda', porcentajeDeIncidencia: this.ponderacionDeRiesgos.moneda, valor: (this.ponderacionDeRiesgos.moneda * (this.debidaDiligencia?.moneda?.factorDeRiesgo))/10},
          /*ESTA MAL; VER CUAL ES*/
          {factor: 'Origen de Fondos', porcentajeDeIncidencia: this.ponderacionDeRiesgos.origenDeFondos, valor: (this.ponderacionDeRiesgos.origenDeFondos * (this.debidaDiligencia?.pais?.factorDeRiesgo))/10},
          {factor: 'Sector de Actividad', porcentajeDeIncidencia: this.ponderacionDeRiesgos.sectorDeActividad, valor: (this.ponderacionDeRiesgos.sectorDeActividad * (this.debidaDiligencia?.sectorIndustrial?.factorDeRiesgo))/10},
          {factor: 'Pais de Operación', porcentajeDeIncidencia: this.ponderacionDeRiesgos.paisDeOperacion, valor: (this.ponderacionDeRiesgos.paisDeOperacion * (this.debidaDiligencia?.pais?.factorDeRiesgo))/10},
          {factor: 'Pais de Residencia del Cliente',  porcentajeDeIncidencia: this.ponderacionDeRiesgos.paisDeResidenciaDelCliente,
              valor: (this.ponderacionDeRiesgos.paisDeResidenciaDelCliente * poneracionpaisResidenciaCliente) / 10},
          {factor: 'Pais de Residencia del Beneficiario', porcentajeDeIncidencia: this.ponderacionDeRiesgos.paisDeResidenciaDelBeneficiario,
              valor: (this.ponderacionDeRiesgos.paisDeResidenciaDelBeneficiario * poneracionpaisResidenciaBeneficiario) / 10},
          {factor: 'Pais de Residencia del Relacionado', porcentajeDeIncidencia: this.ponderacionDeRiesgos.paisDeResidenciaDelRelacionado, valor: 0},
          {factor: 'PEP', porcentajeDeIncidencia: this.ponderacionDeRiesgos.pep, valor: (this.debidaDiligencia?.cliente?.personaFisica?.personaPoliticamenteExpuesta ? this.ponderacionDeRiesgos.pep : 0)},
          /*{factor: 'Tolerancia al Riesgo', porcentajeDeIncidencia: '90%', valor: '90'},*/
      ];

      this.totalCalculo = this.dataSource.reduce((acc, item) => acc + item.valor, 0);
      this.totalCalculoChange.emit(this.totalCalculo);


  }

    // tslint:disable-next-line:typedef
    getDireccionByType(tipo: string, direcciones: any[]) {

        if(!direcciones || direcciones.length == 0) {
            return new Direccion({});
        }

        var direccion = direcciones.find((direccion) => direccion.tipo == tipo);
        return direccion || new Direccion({});
    }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }



}
